import React from 'react';
import { Spinner } from '../../../../../common/index.jsx';
import CategoryForm from './CategoryForm.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import {
  useGetWikiCategoryItemQuery,
  useSaveWikiCategoryMutation,
} from '../../../../../../redux/services/wikiApi.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useTranslation } from 'react-i18next';

const CategoryEdit = ({ mode }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: wikiCategoryItem } = useGetWikiCategoryItemQuery(id, {
    skip: mode === 'create',
  });
  const { saveSuccess: toastSaveSuccess } = useToastMessages();

  const [saveWikiCategory] = useSaveWikiCategoryMutation();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const pageTitle = isCreate ? t('Pridanie kategórie Wiki') : t('Úprava kategórie Wiki');

  if (isEdit && !wikiCategoryItem) {
    return <Spinner />;
  }

  const initials = {
    name: null,
    ...wikiCategoryItem,
  };

  const handleSubmit = async (values) => {
    try {
      const payload = isCreate ? values : { ...values, id };
      await saveWikiCategory(payload).unwrap();
      toastSaveSuccess();
      navigate(routes.cmsWikiCategories);
    } catch (err) {}
  };

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsWikiCategories}
        backUrlTooltip={t('Kategórie Wiki stránok')}
        permissionsBasic={'wiki-categories'}
      />
      <div style={{ margin: '10px' }}>
        <Form initialValues={initials} onFinish={handleSubmit}>
          <CategoryForm />
        </Form>
      </div>
    </>
  );
};

export default CategoryEdit;

